import { AdditionalMessageDisplay } from "../components/AdditionalMessageDisplay";
import { ButtonLink } from "../components/ButtonLink";
import { RFxMailLayout } from "../components/RFxMailLayout";
import { EmailContentProps } from "../types/EmailContent.interface";

export const OnboardingRFxInvitationEmailContent: React.FC<
	EmailContentProps
> = ({ rfxMail }) => {
	const emailData = rfxMail?.emailData;

	if (!emailData) {
		return null;
	}

	const $owner_company_name = emailData.owner_company_name;
	const $additional_message = emailData.additional_message;
	const deadline = rfxMail.deadline_date_time(true);

	return (
		<RFxMailLayout
			$supplier_contact_name={emailData.supplier_contact_name}
			$contact={emailData.contact}
			rfx_type={emailData.rfx_code}
			project_name={emailData.project_name}
			rfx_title={emailData.rfx_title}
			isOnboarding={true}
		>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					<b>{$owner_company_name ?? "[RFx Creator Company Name]"}</b> has
					requested your company to complete{" "}
					<span className="bold italic">onboarding and pre-qualification</span>{" "}
					through <span className="bold">Procuracon.</span> This ensures you’re
					ready to participate in future tender opportunities.
				</td>
			</tr>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					You can start your submission by clicking here and{" "}
					<span className="bold italic">Accepting</span> the request:
				</td>
			</tr>
			<tr>
				<ButtonLink
					isOnboarding
					overrrideText="Onboarding Request"
				/>
			</tr>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					<div className="pb-4"></div>
					All required information and documents will need to be submitted by:-
					<div style={{ textAlign: "left", marginTop: "20px" }}>
						<b>{deadline}</b>
					</div>
				</td>
			</tr>
			<AdditionalMessageDisplay additional_message={$additional_message} />
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					Thank you for taking the time to complete this process.
				</td>
			</tr>
		</RFxMailLayout>
	);
};
